<template>
  <v-dialog v-model="dialogo" width="500" persistent>
    <v-card>
      <v-card-title
        class="headline orange lighten-2"
        transition="dialog-top-transition"
        >Recuperar contraseña</v-card-title
      >
      <v-card-text style="padding-top: 20px"
        >Para recuperar la contraseña es necesario que introduzcas tu correo. Se
        enviará un email al correo indicándote los pasos a seguir para recuperar
        tu contraseña.</v-card-text
      >
      <v-text-field
        style="padding-right: 20px; padding-left: 20px"
        v-model="correo"
        label="Correo"
        @keypress.enter="enviarCorreoUsuario(correo)"
        :rules="reglaCorreo"
        required
      ></v-text-field>
      <v-card-actions>
        <v-btn color="orange" text @click="enviarCorreoUsuario(correo)"
          >Recibir Correo</v-btn
        >
        <v-btn color="black" text @click="dialogo = false">Salir</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialogo: false,
      tituloDialogo: "",
      comentarioDialogo: "",
      botonesDialogo: [],
      correo: "",
      reglaCorreo: [
        (v) => !!v || "Correo Requerido",
        (v) => /.+@.+\..+/.test(v) || "Correo no valido",
      ],
    };
  },
  methods: {
    activarDialogo(correo) {
      return new Promise((resolve) => {
        this.correo = correo;
        this.promesaResolve = resolve;
        this.dialogo = true;
      });
    },
    enviarCorreoUsuario(correo) {
      this.promesaResolve(correo);
      this.dialogo = false;
    },
  },
};
</script>

<style>
</style>
